import React from 'react';
import { Box, Typography } from '@mui/material';
import OnlineIcon from '../../kit/icons/OnlineIcon';
import OfflineIcon from '../../kit/icons/OfflineIcon';

function LocationIcon(format) {
  switch (format) {
    case 'Online':
      return <OnlineIcon />;
    default:
      return <OfflineIcon />;
  }
}

function Location({ location, isLoading }) {
  return (
    <Box sx={{ display: 'flex', gap: 0.5 }}>
      {!isLoading && <Box mt={0.12}>{LocationIcon(location)}</Box>}
      <Typography
        variant="desktopP3"
        fontSize={14}
        ml={location == 'Online' ? 0.25 : 0}
      >
        {location == 'Online' ? 'Онлайн' : location}
      </Typography>
    </Box>
  );
}

export default Location;
